import React from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Checkbox, Chip, TextField, ThemeProvider, createTheme, Tooltip, Typography,InputAdornment  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import ActionDetailPopper from '../../containers/ActionDetailPopper';
import { teams } from '../../assets/staticData';
import YenTextField from '../YenTextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import MultiSelectPrimary from '../MultiSelectPrimary';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../common/StaticExports';
import { useSelector } from 'react-redux';
import PositionAcheivedSelect from '../PositionAcheivedSelect';
import { deleteCompetition } from '../../api/dataCapture';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const CompetionsTable = (props?: any) => {
    const { addData, handleClick, manageState } = props;

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');
  const data = useSelector((state:any) => state.dataCaptures.selectedTeam)?.competitions;
  const [newData, setNewData] = React.useState<any>({});
  const [t] = useTranslation();
  const isAdmin = useSelector((state:any) => state.common.isAdmin);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      data?.length > 0 &&
      stableSort(data, getComparator(order, orderBy)),
    [order, orderBy, data],
  );

  const head = [
    {key: '', displayName: `${new Date().getFullYear() - 1} ${t('DC_7_COMPETITION').toUpperCase()}`},
    {key: '', displayName: t('DC_7_POSITION_ACHIEVED').toUpperCase()},
    {key: '', displayName: ''},
  ]

  const manageChange = (updatedRow:any) => {
    const updatedList = data?.map((row: any) => {
      if (row.id === updatedRow.id) {
        return updatedRow;
      }
      return row;
    });
    manageState(updatedList);
  }

  const manageCreatenew = () => {
    if (newData?.competition) {
      const updatedList = data ? [{...newData, tempId: Math.random()}, ...data] : [{...newData, tempId: Math.random()}];
      manageState(updatedList);
      setNewData({});
      handleClick();
    }
  }
  
  const manageDeleteRow = (row: any) => {
    if (row?.id) {
      deleteCompetition({ id: row?.id });
    }
    const updatedList = data?.filter((d:any) => (d?.id != row?.id || d?.tempId != row?.tempId));
    manageState(updatedList);
  }

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              <TableContainer sx={{ maxHeight: '34vh', overflowY: 'auto' }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    />
                    <TableBody>
                      {
                        !isAdmin && addData &&
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`history-table-row-add-data`}
                        >
                            <TableCell className='fs12'>
                              <TextField 
                              variant='standard' 
                              sx={{ width: '100%' }} 
                              value={newData?.competition}
                              onChange={(e: any) => setNewData({...newData, competition: e.target.value})}
                              error={isEmpty(newData?.competition)}
                              helperText={isEmpty(newData?.competition) ? t('REQUIRED') : ''}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <PositionAcheivedSelect 
                              value={newData?.position}
                              variant={'standard'}
                              manageSelect={(e: any) => setNewData({...newData, position: e})}
                              isError={isEmpty(newData?.position)}
                              errorMessage={t('REQUIRED')}
                              />
                            </TableCell>
                            <TableCell>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {handleClick(); setNewData({});}} className={'icon mr10'} icon={faXmark}/>
                              </Tooltip>
                              <Tooltip title='Create' arrow placement='top'>
                                <FontAwesomeIcon className={'icon mr10'} icon={faCheck} onClick={manageCreatenew}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                      }
                    {
                        visibleRows && visibleRows?.length &&
                        visibleRows?.map((d: any, i: number) => (
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`history-table-row-${i}`}
                        >
                            <TableCell className='fs12'>
                              <TextField 
                              variant='standard' 
                              sx={{ width: '100%' }} 
                              value={d?.competition}
                              onChange={(e: any) => manageChange({...d, competition: e.target.value})}
                              error={isEmpty(d?.competition) && !isAdmin}
                              helperText={isEmpty(d?.competition) ? t('REQUIRED') : ''}
                              disabled={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <PositionAcheivedSelect 
                              value={d?.position}
                              variant={'standard'}
                              manageSelect={(e: any) => manageChange({...d, position: e})}
                              isError={isEmpty(d?.position)&& !isAdmin}
                              errorMessage={t('REQUIRED')}
                              isReadOnly={isAdmin}
                              />
                            </TableCell>
                            <TableCell className='fs12'>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {!isAdmin && manageDeleteRow(d)}} className={isAdmin ? 'icon mr10 deleteIcon cursorNotAllowed' : 'icon mr10 deleteIcon'} icon={faTrash}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default CompetionsTable;